// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25zGX","inner":"Form_inner__2VnI5","range":"Form_range__cd6CY","name":"Form_name__3mqHv","actions":"Form_actions__KX3Q5"};